import { createContext, useContext, useState } from 'react';

export const AuthContext = createContext({
  showAuth: false,
  authPage: 'IniciarSesionWith',
  openAuth: () => {},
  closeAuth: () => {},
  setAuthPage: () => {},
});

export const AuthProvider = ({ children }) => {
  const [showAuth, setShowAuth] = useState(false);
  const [authPage, setAuthPage] = useState('IniciarSesionWith');

  const openAuth = (page = 'IniciarSesionWith') => {
    setAuthPage(page);
    setShowAuth(true);
    // Prevenir scroll del body cuando el popup está abierto
    document.body.style.overflow = 'hidden';
  };

  const closeAuth = () => {
    setShowAuth(false);
    // Restaurar scroll del body
    document.body.style.overflow = 'unset';
  };

  return (
    <AuthContext.Provider value={{
      showAuth,
      authPage,
      openAuth,
      closeAuth,
      setAuthPage,
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

